module.exports = __webpack_public_path__ + "static/media/Fire.3562b81f.mp3";